import { render, staticRenderFns } from "./CoTwoClap.vue?vue&type=template&id=e832b6e8&scoped=true&"
import script from "./CoTwoClap.vue?vue&type=script&lang=js&"
export * from "./CoTwoClap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832b6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e832b6e8')) {
      api.createRecord('e832b6e8', component.options)
    } else {
      api.reload('e832b6e8', component.options)
    }
    module.hot.accept("./CoTwoClap.vue?vue&type=template&id=e832b6e8&scoped=true&", function () {
      api.rerender('e832b6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/CoTwoClap.vue"
export default component.exports